export const filterFormat = (options) => {

    let config = "";

    const prefix = "filter.";

    for (const key_filter in options) {

        const value = options[key_filter];

        if (value) {
            if (config !== "") {
                config += "&"
            }
            let filterValuePrefix = prefix + key_filter
            if (typeof value === 'object') {
                for (const key_value in value) {
                    const atom = value[key_value];

                    if (atom) {

                        if (config !== "") {
                            config += "&"
                        }

                        config += `${filterValuePrefix}.${key_value}=${atom}`
                    }
                }
            } else {
                config += `${filterValuePrefix}=${value}`
            }
        }
    }

    return config;

};